import styled from "styled-components";
import materialUI from "material-UI";
import color from "../../../../constants/color";

export const Container = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden; /* Remove completamente o scroll */
  overscroll-behavior: none; /* Remove o comportamento de overscroll */
`;

export const HeaderModal = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 32px;
`;

export const Body = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  gap: 16px;
  padding: 0 32px 16px 32px;
  overflow: auto;

  /* Estilização da scrollbar */
  &::-webkit-scrollbar {
    width: 6px; /* Largura da scrollbar */
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2); /* Cor da barra de rolagem */
    border-radius: 3px; /* Bordas arredondadas */
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.3); /* Cor ao passar o mouse */
  }

  &::-webkit-scrollbar-track {
    background: transparent; /* Fundo da track */
  }
`;

export const HeaderModalTitle = styled.p`
  color: var(--Cinza-Black, #000);
  /* XXL/Regular */
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.2px;
`;

export const ClearBtn = styled.p`
  font-family: Roboto;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: ${color.primary};
  cursor: pointer;
`;

export const FooterModal = styled.div`
  padding: 24px;
  border-top: 1px solid ${color.LigthGrey};
  width: 100%;
`;

export const Button = styled(materialUI.Button)`
  background: linear-gradient(268.28deg, #06d986 0%, #4a76fb 100%);
  border-radius: 8px;
  width: 100%;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: -0.01em;
  font-family: Inter-Medium;
  color: ${color.White};
  text-transform: capitalize;
  padding: 16px;
`;
